import { Button, Col, Container, Form, Modal, Row, Spinner, Table } from 'react-bootstrap'
import editIcon from '../../../assets/edit.svg'
import checkIcon from '../../../assets/check.svg'
import LicenseRow from './LicenseRow'
import { v4 as uuidv4 } from 'uuid'

export default function EditLicenses({
  licenses,
  editLicense,
  setEditLicense,
  isAddLicenceWip,
  setIsAddLicenceWip,
  isEditLicenceWip,
  handleSnackOpen,
  setLoading,
  licenseEventListener,
}) {
  return (
    <Col style={{ flex: 2.5 }}>
      <Row style={spaceOut}>
        <div
          style={{
            fontSize: 28,
            color: 'rgba(0, 127, 97, 1)',
            textTransform: 'capitalize',
            fontFamily: 'GT Super Display',
            fontWeight: '500',
            marginTop: 60,
          }}
        >
          Manage Licenses
        </div>
        {!editLicense ? (
          <Button
            variant="light"
            onClick={() => {
              setEditLicense(true)
            }}
            style={{
              width: 180,
              height: 40,
              marginLeft: 20,
              borderRadius: 8,
              backgroundColor: 'rgba(0, 127, 97, 1)',
              fontSize: 20,
              fontWeight: '600',
              lineHeight: '100%',
              color: 'rgba(253, 250, 241, 1)',
              border: 'none',
              marginRight: 40,
              letterSpacing: 1.5,
            }}
          >
            <img alt="" src={editIcon} style={{ objectFit: 'contain', height: 15 }} />
            &nbsp;&nbsp;Edit License
          </Button>
        ) : (
          <Row>
            <Button
              variant="light"
              onClick={() => {
                if (isAddLicenceWip === true || isEditLicenceWip === true) {
                  handleSnackOpen('Please complete or discard the in-progress edit/add', 'error')
                  return
                }
                setEditLicense(false)
              }}
              style={{
                width: 'auto',
                height: 40,
                marginLeft: 20,
                borderRadius: 8,
                backgroundColor: 'rgba(0, 127, 97, 1)',
                fontSize: 20,
                fontWeight: '600',
                lineHeight: '100%',
                color: 'rgba(253, 250, 241, 1)',
                border: 'none',
                marginRight: 40,
                letterSpacing: 1.5,
              }}
            >
              <img alt="done" src={checkIcon} style={{ height: 18, filter: 'invert(1)', objectFit: 'contain' }} />
              &nbsp;&nbsp;Done editing
            </Button>
          </Row>
        )}
      </Row>
      <Table borderless>
        <tr style={{ background: 'transparent' }} className="TableHeaderRow">
          <td style={{ opacity: 0.6, fontWeight: '600', letterSpacing: 1.5 }} className="HeaderTd">
            State
          </td>
          <td style={{ opacity: 0.6, fontWeight: '600', letterSpacing: 1.5 }} className="HeaderTd">
            License Number
          </td>
          <td style={{ opacity: 0.6, fontWeight: '600', letterSpacing: 1.5 }} className="HeaderTd">
            Expiration
          </td>
          <td style={{ opacity: 0.6, fontWeight: '600', letterSpacing: 1.5 }} className="HeaderTd">
            In Good Standing
          </td>
          <td style={{ opacity: 0.6, fontWeight: '600', letterSpacing: 1.5 }} className="HeaderTd">
            Acknowledgement
          </td>
          <td style={{ opacity: 0.6, fontWeight: '600', letterSpacing: 1.5 }} className="HeaderTd"></td>
        </tr>

        {licenses && licenses.map(li => <LicenseRow isEditView={editLicense} license={li} toggleLoading={setLoading} eventListener={licenseEventListener} />)}

        {editLicense && (
          <tr style={{ background: 'transparent' }}>
            <td></td>
            <td></td>
            <td>
              <Button
                variant="light"
                onClick={() => {
                  if (isAddLicenceWip === true || isEditLicenceWip === true) {
                    handleSnackOpen('Please complete the in-progress edit/add', 'error')
                    return
                  }
                  const initLicense = {
                    isNewAdd: true,
                    uniqueId: uuidv4(),
                    state: '',
                    licenseId: '',
                    expirationDate: '',
                    isGoodStanding: '',
                    ackPermissionToPractice: '',
                  }
                  setIsAddLicenceWip(true)
                  licenses?.push(initLicense)
                }}
                style={{
                  width: 'auto',
                  height: 'auto',
                  borderRadius: 8,
                  backgroundColor: 'rgba(0, 127, 97, 1)',
                  color: 'rgba(253, 250, 241, 1)',
                  border: 'none',
                }}
              >
                <img alt="done" src={checkIcon} style={{ height: 12, objectFit: 'contain', filter: 'invert(1)' }} />
                &nbsp;&nbsp;Add New License
              </Button>
            </td>
            <td></td>
            <td></td>
          </tr>
        )}
      </Table>
    </Col>
  )
}

const spaceOut = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}
